import { createContext, useContext, useState, type ReactNode } from 'react';
import type { IconName } from '../components/Icon.js';

export interface TopBarOverride {
  title?: string;
  subtitle?: string;
  heroIcon?: IconName;
  heroIconColor?: string;
  bottomActions?: ReactNode;
}

type Ctx = { override: TopBarOverride; setOverride: (v: TopBarOverride) => void };

const TopBarCtx = createContext<Ctx>({ override: {}, setOverride: () => {} });

export function TopBarProvider({ children, initialOverride }: { children: ReactNode; initialOverride?: TopBarOverride }) {
  const [override, setOverride] = useState<TopBarOverride>(initialOverride ?? {});
  return <TopBarCtx.Provider value={{ override, setOverride }}>{children}</TopBarCtx.Provider>;
}

export function useTopBarCtx() {
  return useContext(TopBarCtx);
}
